import { SVGProps } from 'react';
import { tokens } from '../../core/theme';

type StoreIconProps = SVGProps<SVGSVGElement> & { color?: string };

export const StoreIcon = ({
  width = 24,
  height = 24,
  color = tokens.colors.brand.red.DEFAULT,
  ...props
}: StoreIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M26.6667 26.6667V13.04"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.73467 13.0373C3.47067 13.0213 1.99467 10.78 2.976 8.848L5.264 4.34533C5.784 3.31867 6.88 2.66667 8.08267 2.66667H23.9173C25.12 2.66667 26.216 3.31867 26.7373 4.34533L29.0253 8.848C30.0067 10.78 28.5307 13.0213 26.2667 13.0373C24.3773 13.0373 22.8453 11.7467 22.8453 10.1533V10.0893C22.8453 11.7173 21.3133 13.0373 19.424 13.0373C17.532 13.0373 16 11.7173 16 10.0893C16 11.7173 14.468 13.0373 12.5787 13.0373C10.6893 13.0373 9.15733 11.7173 9.15733 10.0893V10.1533C9.156 11.7467 7.624 13.0373 5.73467 13.0373Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3333 26.6667H28"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.13333 19.9333H14.6667L13.7333 24.6H7.06667L5.73333 17.9333H4.06667"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1133 27.8867C13.14 27.9133 13.14 27.9547 13.1133 27.9813C13.0867 28.008 13.0453 28.008 13.0187 27.9813C12.992 27.9547 12.992 27.9133 13.0187 27.8867C13.0453 27.86 13.088 27.86 13.1133 27.8867"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.78 27.8867C7.80667 27.9133 7.80667 27.9547 7.78 27.9813C7.75333 28.008 7.712 28.008 7.68533 27.9813C7.65867 27.9547 7.65867 27.9133 7.68533 27.8867C7.712 27.86 7.75467 27.86 7.78 27.8867"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
